/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WindowSize } from '../WindowSize.js';
import { useNavigate } from 'react-router-dom';
import { GetUrl } from '../Utility.js';

import Pool from './Pool.js';
import Title from './Title.js';
import TypeSelect from './TypeSelect.js';
import PredictionTitle from './PredictionTitle.js';
import PredictionBox from './PredictionBox.js';
import BettingBox from './BettingBox.js';
import PredictionText from './PredictionText.js';
import PredictionRecordBox from './PredictionRecordBox.js';
import TotalRecordBox from './TotalRecordBox.js';
import RechargePointModal from './RechargePointModal.js';
import TimeTicketBuyModal from './TimeTicketBuyModal.js';
import TimeTicketUseModal from './TimeTicketUseModal.js';
import ServiceCenterModal from './ServiceCenterModal.js';
import DetailModalType1 from './DetailModalType1.js';
import DetailModalType2 from './DetailModalType2.js';
import WriteModalType from './WriteModalType.js';

function Client() {

  const state=useSelector((state)=>state);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const width = 1920;
  const height = 1080;

  const Reset = async () => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
              alert('유저 정보 만료(다시 로그인 해주세요)');  
              navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
              return;    
            }
            
            dispatch({type:'Request'});
            //const response = await fetch('http://13.208.99.210:5000/UserInfo/UserInfo', {
            const response = await fetch(GetUrl() + 'UserInfo/UserInfo', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey }),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                  dispatch({type:'UserInfo', NickName:data.nick_name, Point:data.point, RemainTime:data.remain_time});
                }
                else if(data.result === 3)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 1)
                {
                    alert('유저 정보 찾을 수 없습니다.(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            dispatch({type:'Response'});
            console.error(error);
        }
    };

  const checkMobile = () => {
    const varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf('android') > -1) {
      //안드로이드
      return "android";
    } else if (varUA.indexOf("iphone") > -1 || varUA.indexOf("ipad") > -1 || varUA.indexOf("ipod") > -1) {
      //IOS
      return "ios";
    } else {
      //아이폰, 안드로이드 외
      return "other";
    }
  }

  useEffect(() => {
    const isDevToolsMobileEmulation = () => {
      return /\bMobile/.test(navigator.userAgent) && !('ontouchstart' in window);
    };

    const handleSize = (event = null) => {
      if (isDevToolsMobileEmulation()) {

        // Logic for when Chrome Developer Tools' Mobile View is toggled on
        if (window.innerWidth > 480) {
          WindowSize(width, height, 'PC90', height, 'no');
          
        }
        else {
          WindowSize(width, height, 'ELSE', height, 'no');
          
        }
      }
      else {
        if (window.innerWidth > 480) {
          WindowSize(width, height, 'PC90', height, checkMobile());
         
        }
        else {
          WindowSize(width, height, 'ELSE', height, checkMobile());
         
        }
      }
    }

    window.addEventListener('orientationchange', handleSize);
    window.addEventListener('resize', handleSize);
    handleSize();

    // client page 열때 우선 reset 패킷을 보낸다.
    Reset();
    return () => {
      window.removeEventListener('resize', handleSize);
      window.removeEventListener('orientationchange', handleSize);
    };

  }, []);

  const closeRechargePointModal = () => {
    dispatch({type:'UpdateRechargePointModal', View:false});
  }

  const closeTimeTicketBuyModal = () => {
    dispatch({type:'UpdateTimeTicketBuyModal', View:false});
  }

  const closeTimeTicketUseModal = () => {
    dispatch({type:'UpdateTimeTicketUseModal', View:false});
  }

  const closeServiceCenterModal = () => {
    dispatch({type:'UpdateServiceCenterModal', View:false});
  }

  const closeDetailModalType1 = () => {
    dispatch({type:'UpdateDetailModalType1', View:false, Type:0, No:0});
  }

  const closeDetailModalType2 = () => {
    dispatch({type:'UpdateDetailModalType2', View:false, No:0});
  }

  const closeWriteModalType = () => {
    dispatch({type:'UpdateWriteModal', View:false});
  }

  return (
    <div id='Player_Range'>
        <BettingBox></BettingBox>
        <Title></Title>
        <Pool></Pool>
        <TypeSelect></TypeSelect>
        <TotalRecordBox></TotalRecordBox>
        <PredictionText></PredictionText>        
        <RechargePointModal isOpen={state.recharge_point_modal} onClose={closeRechargePointModal} ></RechargePointModal>
        <TimeTicketBuyModal isOpen={state.time_ticket_buy_modal} onClose={closeTimeTicketBuyModal} ></TimeTicketBuyModal>
        <TimeTicketUseModal isOpen={state.time_ticket_use_modal} onClose={closeTimeTicketUseModal} ></TimeTicketUseModal>
        <ServiceCenterModal isOpen={state.service_center_modal} onClose={closeServiceCenterModal} ></ServiceCenterModal>
        <DetailModalType1 isOpen={state.detail_modal_type1_open} Type={state.detail_modal_type1_type} No={state.detail_modal_type1_no} onClose={closeDetailModalType1} ></DetailModalType1>
        <DetailModalType2 isOpen={state.detail_modal_type2_open} No={state.detail_modal_type2_no} onClose={closeDetailModalType2} ></DetailModalType2>
        <WriteModalType isOpen={state.write_modal_open} onClose={closeWriteModalType}></WriteModalType>
    </div>
  );
}

export default Client;